import { useAct } from 'FlowBuilder/store'

export default function FundraiseUpActionForm({ actionId }) {
    const act = useAct()

    const action = useSel(s => s.actions.entities[s.local.selectedActionId])
    const config = action.config || { elementCode: '' }

    function update(data) {
        act.actions.upsert(actionId, { config: { ...config, ...data } })
    }

    return <div className="box narrow">
        <h2 className='no-margin-top'>Fundraise Up donation form</h2>
        <div className='field margin-top'>
            <label className="bold">Element Embed Code</label>
            <input type='text' className='full-width margin-top' value={config.elementCode} onChange={e => update({ elementCode: e.target.value })} />
        </div>
    </div>
}

